import React from 'react';
import { Link } from 'react-router-dom';

const PartnershipsSection = () => {
  return (
    <section className="py-8 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900">Members and Partners</h2>
          <p className="mt-2 text-base text-gray-600">
            Working together with trusted organizations to deliver exceptional experiences
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm">
            <div className="w-24 h-24 mb-3 rounded-lg overflow-hidden">
              <img 
                src="https://imgur.com/MXNquKw.jpg" 
                alt="Uganda Tourism Board"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-base font-semibold text-gray-900 mb-1">Uganda Tourism Board</h3>
            <p className="text-sm text-gray-600 text-center">Official tourism partner for promoting Uganda's destinations</p>
          </div>

          <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm">
            <div className="w-24 h-24 mb-3 rounded-lg overflow-hidden">
              <img 
                src="https://imgur.com/cnAl3rt.jpg" 
                alt="Partner"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-base font-semibold text-gray-900 mb-1">Partner</h3>
            <p className="text-sm text-gray-600 text-center">Trusted partner in delivering exceptional experiences</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-600 mb-3">Interested in partnering with us?</p>
          <Link 
            to="/partnership"
            className="inline-flex items-center px-6 py-2 border border-ta-green text-ta-green rounded-md hover:bg-ta-green hover:text-white transition-colors"
          >
            Learn More About Partnerships
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PartnershipsSection;